import React, { FunctionComponent } from 'react';
import { ResumeStates, JobResumeStates } from '../../../types/personShow';
import { FlashBox } from '../../atoms/flashBox';
import { Loading } from '../../atoms/loading';

type Props = {
  isPc: boolean;
  target: 'resume' | 'job_resume';
  resume: ResumeStates;
  jobResume: JobResumeStates;
  flash: boolean;
  flashClass: string;
  flashMessage: string;
  deleted: boolean;
  fileInputRef: React.RefObject<HTMLInputElement>;
  loading: boolean;
  onFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFlash: (flash: boolean, flashType: string, flashMessage: string) => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  isPc,
  target,
  resume,
  jobResume,
  flash,
  flashClass,
  flashMessage,
  deleted,
  fileInputRef,
  loading,
  onFileInputChange,
  handleFlash,
}) => {
  const getTitle = () => (target === 'resume' ? '履歴書' : '職務経歴書');

  const renderPreview = () => {
    const data = target === 'resume' ? resume.resume : jobResume.job_resume
    if (!data || typeof data === 'string') return null

    let fullUrl = '';
    if (data instanceof File) {
      // ブラウザ内で選択したローカルファイルのその場プレビュー
      fullUrl = URL.createObjectURL(data);
    } else if (data && typeof data === 'object' && 'name' in data) {
      // アップロード済みファイルは、Rails側の認証・認可付き配信ルート
      // (People::ResumesController#download_resume / JobResumesController#download_job_resume、
      // preview=trueでinline配信)のパスがAPIから返ってくる。
      // 既に絶対URL(blob:等)の場合はそのまま、相対パスの場合はoriginと結合する。
      const url = (data as any).name?.url || '';
      fullUrl = url ? new URL(url, window.location.origin).href : '';
    }
    const updatedAt = target === 'resume' ? resume?.resumeUpdatedAt : jobResume?.jobResumeUpdatedAt

    return (
      <>
        <object data={`${fullUrl}#toolbar=0&navpanes=0`} type="application/pdf" className="pdf" />
        {updatedAt && <p>最終アップロード日：{updatedAt}</p>}
      </>
    )
  };

  // スマホ用
  const uploadedData = target === 'resume' ? resume.resume : jobResume.job_resume;
  let fileName = '未アップロード';
  let uploadedAt = '-/-/-';
  if (uploadedData instanceof File) {
    fileName = uploadedData.name; // 今アップロードした直後
    const now = new Date();
    uploadedAt = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, '0')}/${String(
      now.getDate()
    ).padStart(2, '0')}`;
  } else if (uploadedData && typeof uploadedData === 'object' && 'name' in uploadedData) {
    fileName = 'アップロード済'; // すでに保存済み
    uploadedAt =
      target === 'resume' ? resume?.resumeUpdatedAt || '-/-/-' : jobResume?.jobResumeUpdatedAt || '-/-/-';
  }
  const fileNameStateClass = fileName === '未アップロード' ? 'is-empty' : fileName === 'アップロード済' ? 'is-saved' : '';

  return (
    <>
      <FlashBox
        flash={flash}
        flashType={flashClass}
        flashMessage={flashMessage}
        handleFlash={handleFlash}
      />
      <div className="person__show__modal__inner">
        {loading && (
          <div className="person__show__modal__inner__resumes__loading">
            <Loading />
          </div>
        )}
        <p className="person__show__modal__inner--title">
          <span className="main">{getTitle()}をアップロードして保存してください</span>
          <span className="subtitle">※ファイル形式：PDF&emsp;ファイルサイズ：1MBまで</span>
          <span className="subtitle">※エントリー企業にのみ公開されます</span>
          <span className="subtitle">※アップロードできる書類は1ファイルのみです、複数社にエントリーする場合は「志望動機」は未記入にしてください</span>
        </p>

        {isPc && <div className="person__show__modal__inner__resumes">{renderPreview()}</div>}

        {!isPc && (
          <div className="person__show__modal__inner__resumes">
            <div className="uploaded-box">
              <p className="uploaded-box__title">アップロード状況</p>
              <div className="uploaded-box__row">
                <span className={`uploaded-box__row-filename ${fileNameStateClass}`}>{fileName}</span>
                <span className="uploaded-box__row-date">{uploadedAt}</span>
              </div>
            </div>
          </div>
        )}

        <div className="person__show__modal__inner__resumes--btns">
          <div className="btnCover">
            <label className="upload">
              <span>アップロード</span>
              <input
                type="file"
                accept="application/pdf"
                ref={fileInputRef}
                onChange={onFileInputChange}
              />
            </label>
          </div>
          <p className="new">新規作成</p>
        </div>
      </div>
    </>
  );
};
